import { PaginationStore } from "stores/data/pagination.store"
import { computed, observable, transaction, makeObservable } from "mobx"
import { EntityToUpdate } from "abstract/entity-to-update"
import { RootStore } from "stores/root.store"
import {
  deleteNotification,
  createNotification,
  getNotification,
  sendNotification,
  getNotifications,
  updateNotification,
} from "../api"
import { WinNotificationType, WinNotificationsResponse } from "./types"

export class WinNotificationsStore extends PaginationStore<WinNotificationsResponse, string> {
  @observable
  private _notifications: WinNotificationsResponse[] = []
  @observable
  private _selectedElement: WinNotificationsResponse = {} as WinNotificationsResponse

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }

  async getData(): Promise<WinNotificationsResponse[]> {
    this.resetFuncAfterSuccess()
    const { page, limit } = this.pagination

    const res = await this.defaultFunction(getNotifications, this.filter, page, limit)

    transaction(() => {
      this._notifications = res.data
      this.total = res.total
    })

    return res.data
  }

  async createNotification(data: EntityToUpdate<WinNotificationType>) {
    await this.defaultFunction(createNotification, data)
  }

  async updateNotification(id: string, data: EntityToUpdate<WinNotificationType>) {
    await this.defaultFunction(updateNotification, id, data)
  }

  async deleteNotificationById(id: string) {
    await this.defaultFunction(deleteNotification, id)
  }

  async getNotificationById(id: string) {
    await this.defaultFunction(getNotification, id)
  }

  async sendNotificationById(id: string) {
    await this.defaultFunction(sendNotification, id)
  }

  @computed
  get notifications(): WinNotificationsResponse[] {
    return this._notifications
  }

  @computed
  get selectedElement(): WinNotificationsResponse {
    return this._selectedElement
  }

  set selectedElement(value: WinNotificationsResponse) {
    this._selectedElement = value
  }

  clearSelectedElement() {
    this._selectedElement = {} as WinNotificationsResponse
  }
}
